module.exports = "<svg viewBox=\"0 0 30.9 35.7\"><path d=\"M30.9 17.9L0 0v35.7l30.9-17.8z\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/youtube.svg
// module id = 309
// module chunks = 1